import React, { useState } from "react";
import logo from "../assets/armin-logo-3.png";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";

export default function Footer() {
  const [expanded, setExpanded] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#333] text-white">
      <div className="mx-auto max-w-7xl px-6 py-6">
        {/* Logo and Toggle Button */}
        <div className="flex justify-between items-center">
          <img src={logo} alt="Armin AI Logo" className="h-10 w-auto" />
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-gray-400 hover:text-white transition"
            aria-label={expanded ? "Collapse footer" : "Expand footer"}>
            {expanded ? (
              <MinusIcon className="h-5 w-5" />
            ) : (
              <PlusIcon className="h-5 w-5" />
            )}
          </button>
        </div>

        {/* Expanded Content */}
        {expanded && (
          <div className="mt-6 md:flex md:items-center md:justify-between">
            <p className="text-sm text-gray-400 text-center md:text-left">
              &copy; {currentYear} Armin Real Estate. All rights reserved.
            </p>
          </div>
        )}
      </div>
    </footer>
  );
}
